import { useEffect, useRef, useState } from 'react';

interface useHandleTimerProps {
  totalTime: number;
}

const useHandleTimer = ({ totalTime }: useHandleTimerProps) => {
  const [isTimerWork, setIsTimerWork] = useState(false);
  const [time, setTime] = useState(totalTime);

  const timerRef = useRef<number | null>(null);

  useEffect(() => {
    if (isTimerWork) {
      timerRef.current = window.setInterval(() => {
        setTime((prev) => {
          if (prev <= 0) {
            if (timerRef.current) {
              clearInterval(timerRef.current);
            }
            setIsTimerWork(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [isTimerWork]);

  const handleTimerStart = () => {
    setIsTimerWork(true);
  };

  const handleTimerEnd = () => {
    setIsTimerWork(false);
  };

  const handleTimerInit = () => {
    setTime(totalTime);
  };

  return {
    time,
    handleTimerStart,
    handleTimerEnd,
    handleTimerInit,
  };
};

export default useHandleTimer;
